import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { JwtHelper } from 'angular2-jwt';
import { User } from '../models/User.model';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { environment } from '../../environments/environment';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { ImpersonationData } from '../models/ImpersonationData';

import { ICompanyContactLoginByEmail } from '../models/ICompanyContactLoginByEmail.model';

@Injectable()
export class AuthService {
    private jwtHelper: JwtHelper;
    private user: User;
    private token: string;

    constructor(private http: HttpClient) {
        this.jwtHelper = new JwtHelper();
    }

    public setImpersonationData(companyContactId: number, sysUserId: number) {
        const data = {} as ImpersonationData;
        data.ImpersonatedId = companyContactId;
        data.SysUserId = sysUserId;
        localStorage.setItem('impersonation-data', JSON.stringify(data));
    }

    public getImpersonationData(): ImpersonationData {
        return JSON.parse(localStorage.getItem('impersonation-data'));
    }

    private setLoginInfo(loginInfo: ILoginInfo) {
        if (!(loginInfo || {} as ILoginInfo).token) return;

        localStorage.setItem('token', loginInfo.token);

        const tokenData = this.jwtHelper.decodeToken(loginInfo.token);

        this.user = new User();
        this.user.Id = parseInt(tokenData.jti as string, 10);
        this.user.FirstName = loginInfo.first;
        this.user.LastName = loginInfo.last;
        this.user.Username = loginInfo.login;
        this.user.Nickname = loginInfo.nick;
        this.user.Type = loginInfo.userType;

        localStorage.setItem('user', JSON.stringify(this.user));
    }

    login(login: string, password: string): Observable<boolean> {
        this.user = null;
        this.token = null;
        localStorage.clear();

        if (!login || !password) return Observable.of(false);

        return this.http
            .post<ILoginInfo>(`${environment.authBase}auth/token`, { u: login, p: password })
            .do(loginInfo => {
                loginInfo.login = login;
                this.setLoginInfo(loginInfo);
            })
            .map(response => !!response);
    }

    logout(): void {
        this.user = null;
        this.token = null;
        localStorage.clear();
    }

    getUser(): User {
        return this.user || (this.user = JSON.parse(localStorage.getItem('user')) as User);
    }

    getToken(): string {
        return this.token || (this.token = localStorage.getItem('token'));
    }

    isAuthenticated(): boolean {
        const token = this.getToken();
        return !!token && !this.jwtHelper.isTokenExpired(token);
    }

    checkUsername(username: string): Observable<boolean> {
        return this.http.get<boolean>(`${environment.authBase}login/check-username/${username}`);
    }

    updateLoginInfo(login: string, password: string): Observable<void> {
        if (!login || !password) return new EmptyObservable();

        return this.http
            .post<ILoginInfo>(`${environment.authBase}login/update`, { u: login, p: password })
            .do(() => {
                this.user.Username = login;
                localStorage.setItem('user', JSON.stringify(this.user));
            })
            .map(response => undefined);
    }

    forgotPassword(login: string): Observable<any> {
        let loc = window.location;
        let emailUrl = loc.protocol + '//' + loc.hostname;
        if (loc.port && (loc.port != '0' && loc.port != '80' && loc.port != '443')) {
            emailUrl = emailUrl + ':' + loc.port;
        }
        return this.http.post<any>(`${environment.portalBase}accounts/forgot-password`, { email: login, serverHost: emailUrl });
    }

    getCompanyContactLoginByEmail(email: string): Observable<ICompanyContactLoginByEmail> {
        return this.http.post<ICompanyContactLoginByEmail>(`${environment.portalBase}accounts/get-company-contact-login-by-email`, { Email: email });
    }
}

interface ILoginInfo {
    login: string | undefined;
    first: string | undefined;
    last: string | undefined;
    nick: string | undefined;
    token: string;
    userType: number;
}




// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts